import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface EventCardSkeletonProps {
  className?: string;
}

export function EventCardSkeleton({ className }: EventCardSkeletonProps) {
  return (
    <Card
      className={cn('w-full overflow-hidden rounded-2xl border border-card-border p-0', className)}
    >
      <AspectRatio ratio={16 / 9}>
        <Skeleton className="absolute inset-0 rounded-none" />
      </AspectRatio>
      <CardContent className="min-w-0 space-y-2 pb-4 pt-3.5">
        <Skeleton className="h-5 w-4/5" />
        <Skeleton className="h-3.5 w-2/5" />
        <Skeleton className="h-3 w-1/3" />
      </CardContent>
    </Card>
  );
}
